async function login(data, urls, Formatter, Network) {
  const url = urls.login
  const response = await sendRequest(data, url, Network)
  const parsedResponse = parseResponse(response, Formatter, Network, data)
  return parsedResponse
}

async function sendRequest(data, url, Network) {
  // return { status: { code: 404 } }
  const reqData = {
    email: data.email,
    password: data.password,
  }
  const response = await Network.sendPostRequest(url, reqData)
  return response
}

function parseResponse(response, Formatter, Network, data) {
  if (
    response &&
    (response.status.code === 200 || response.status.code === 201)
  ) {
    const rawUser = response.response.user
    const user = Formatter.parseExternalUser(rawUser)

    return {
      success: true,
      user,
    }
  }
  // if (data.email == 'test@gmail.com' && data.password == 'test@gmail.com') {
  //   return {
  //     success: true,
  //     user: Formatter.parseExternalUser({
  //       email: 'test@gmail.com',
  //       firstName: 'John',
  //       id: 'iketa',
  //       lastName: 'doe',
  //       metadata: {},
  //       phoneNumber: '2290166666666',
  //     }),
  //   }
  // }
  if (response.status.code === 404) {
    return {
      success: false,
      userNotFound: true,
      messageId: 'messages.login.userNotFound',
    }
  }
  if (response.status.code === 401) {
    return {
      success: false,
      badPassword: true,
      messageId: 'messages.login.badPassword',
    }
  }
  return Network.defaultResponseParsing(response)
}

export { login }
